import { useState, useEffect } from 'react'
import { TreeView, createTreeCollection, Box } from '@chakra-ui/react'
import { LuFile, LuFolder, LuChevronRight } from 'react-icons/lu'

export default function Tree ({ label, structure }) {
  const [collection, setCollection] = useState(createTreeCollection({
    nodeToValue: (node) => node.id,
    nodeToString: (node) => node.name,
    rootNode: {
      id: 'ROOT',
      name: '',
      children: structure || []
    }
  }))

  useEffect(() => {
    if (structure) {
      setCollection(createTreeCollection({
        nodeToValue: (node) => node.id,
        nodeToString: (node) => node.name,
        rootNode: {
          id: 'ROOT',
          name: '',
          children: structure
        }
      }))
    }
  }, [structure])

  return (
    <TreeView.Root collection={collection} animateContent expandOnClick={false}>
      {label && <TreeView.Label>{label}</TreeView.Label>}
      <TreeView.Tree>
        <TreeView.Node
          indentGuide={<TreeView.BranchIndentGuide />}
          render={({ node, nodeState }) =>
            nodeState.isBranch
              ? (
                <TreeView.BranchControl>
                  <TreeView.BranchTrigger>
                    <TreeView.BranchIndicator asChild>
                      <LuChevronRight />
                    </TreeView.BranchIndicator>
                  </TreeView.BranchTrigger>
                  <LuFolder />
                  <TreeView.BranchText>{node.display || node.name}</TreeView.BranchText>
                </TreeView.BranchControl>
                )
              : (
                <TreeView.Item>
                  <LuFile />
                  <TreeView.ItemText onClick={e => e.stopPropagation()}>{node.display || node.name}</TreeView.ItemText>
                  {node.actions && <Box onClick={e => e.stopPropagation()}>{node.actions}</Box>}
                </TreeView.Item>
                )}
        />
      </TreeView.Tree>
    </TreeView.Root>
  )
}
